import { NotificationCard } from '@/components/client/notification/NotificationCard';
import type { PlayerNotification } from '@/services/notificationService';
import { notificationDateGroup } from '@/utils/notificationTime';

interface NotificationListProps {
  items: PlayerNotification[];
  onOpen: (item: PlayerNotification) => void;
}

export function NotificationList({ items, onOpen }: NotificationListProps) {
  let lastGroup = '';

  return (
    <div className="space-y-3">
      {items.map((item) => {
        const group = notificationDateGroup(item.createdAt);
        const showGroup = group !== lastGroup;
        lastGroup = group;
        return (
          <div key={item.id}>
            {showGroup ? (
              <p className="text-[11px] font-semibold tracking-wide text-gray-400 mb-2 mt-4 first:mt-0">
                {group}
              </p>
            ) : null}
            <NotificationCard item={item} onOpen={onOpen} />
          </div>
        );
      })}
    </div>
  );
}
